import instance from './http'
import url from './url'

export default {
  events: () => instance.get(url.events),
  GetEventData: (eventid) => instance.get(url.GetEventData(eventid)),
  FetchEventData: (eventHash) => instance.get(url.fetchEventData(eventHash)),
}
